/** Дата в ячейках таблицы: «18 мая 2025». */
export const PA_TABLE_DATE_FORMAT = 'dd MMMM yyyy';

/** Дата и время в ячейках таблицы: «18 мая 2026 17:15». */
export const PA_TABLE_DATETIME_FORMAT = 'dd MMMM yyyy HH:mm';

export const PA_TABLE_DATE_LOCALE = 'ru-RU';
